import "./module.css";
import { useState, useRef } from "react";
import { useForm } from "react-hook-form";
import { Button } from "shared/Components/button";
import { TextInput } from "shared/Components/textInput";
import { client } from "helper/apolloConfig";
import { ResetPasswordResolver } from "validators/UserValidation";
import { globalVariables } from "helper/globalVariables";
import AuthLayout from "shared/Components/authLayout";
import { SET_NEW_PASSWORD_MUTATION } from "redux/features/passwordSlice/passwordGql";
import { useLocation, useNavigate } from "react-router-dom";

const ResetPassword = () => {
  const location = useLocation();
  const { access_token } = location.state && location.state?.data;
  const navigate = useNavigate();
  const modalRef = useRef();
  const [modal, setModal] = useState({
    title: "",
    desc: "",
    type: "pending",
  })
  const {
    handleSubmit,
    formState: { errors },
    register,
  } = useForm({
    resolver: ResetPasswordResolver,
    defaultValues: { password: "", confirmPassword: "" },
  });
  const [loading, setLoading] = useState();
  const onSubmit = async (values) => {
    // send api call
    setLoading(true);
    const payload = {
      new_password: values.password,
      access_token: access_token,
    };
    try {
      const result = await client.mutate({
        mutation: SET_NEW_PASSWORD_MUTATION,
        variables: { data: payload },
      });
      // if (result.data.success) {
      setModal({
        title: globalVariables.restPasswordSuccess,
        desc: globalVariables.restPasswordDescription,
        type: "success",
        actionButton: {
          label: "Go to Login",
          onClick: () => navigate('/login'),
        },
      });
      modalRef.current.openModal();
      // }
      setLoading(false);
    }
    catch (error) {
      modalRef.current.openModal();
      setModal({
        title: globalVariables.restPasswordSuccess,
        desc: error?.message,
        type: "pending",
      });
      setLoading(false);
    }
  };

  const onCloseModal = () => {
    // No longer needed - action button handles navigation
  };

  return (
    <AuthLayout apiData={modal} ref={modalRef} onCloseModal={onCloseModal}>
      <span className="pt-4 text-gray-900 font-semibold text-3xl">
        {globalVariables.resetPassword}
      </span>
      <span className="pt-3 text-gray-500 font-regular text-base">
        {globalVariables.enterNewPassword}
      </span>
      <div className="mt-6" />
      <form
        onSubmit={handleSubmit((d) => console.log("d===", d))}
        className="max-[400px]:w-[90%]"
      >
        <div className="mt-4" />
        <TextInput
          register={register}
          name="password"
          label={globalVariables.newPassword}
          placeholder={globalVariables.tempPassword}
          errorMsg={errors.password?.message}
          type="password"
        />

        <div className="mt-4" />
        <TextInput
          register={register}
          name="confirmPassword"
          label={globalVariables.confirmPassword}
          type="password"
          placeholder={globalVariables.tempPassword}
          errorMsg={errors.confirmPassword?.message}
        />
        <div className="mt-6" />

        <Button label={"Reset Password"} onClick={handleSubmit(onSubmit)} disabled={loading} />
      </form>
    </AuthLayout>
  );
};
export default ResetPassword;
